import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import {  FilterItem, FilterType, InputType, PagingOptions, TagsInputOptions, TextBoxOptions } from 'bnsights-control-library';
import { PageInfoService } from '../../../_metronic/core/services/page-info.service';
import { DepartmentModel } from '../../shared/models/DepartmentModels/DepartmentModel';
import { DepartmentUsersIDRequestModel } from '../../shared/models/DepartmentModels/DepartmentUsersIDRequestModel';
import { DataSecretService } from '../../shared/Services/data.service';
import { DepartmentService } from '../../shared/Services/DepartmentService.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService, UtilityService, BBSFTranslateService, EnvironmentService } from 'bnsights-utilities-library';


@Component({
  selector: 'lib-department-info',
  templateUrl: './department-info.component.html'
})
export class DepartmentInfoComponent implements OnInit {
  SubheaderTitle: string;
  ShowToolbar = true;
  ShowbreadCrumb = true;
  ShowBreadcrumbSecond: true;
  BreadcrumbTitle : string= this.utilityService.getResourceValue('Sectors');
  BreadcrumbTitleSecond = this.utilityService.getResourceValue('Departments');
  Url="/Admin/Sectors/Sector"
  SecondUrl=""
  ApiUrl = "/api/admin/Department/"
  searchTextBox: TextBoxOptions;
  DepartmentIdTextBox: TextBoxOptions;
  filterForm = new FormGroup({});
  UserDepartmentForm = new FormGroup({});
  showFilter: boolean = false;
  UserDepartmentPagingResult: any[] = [];
  UserDepartmentPaging: PagingOptions;
  TextInputFilter: FilterItem;
  DepartmentIdTextInputFilter: FilterItem;
  IsFilterLoaded: boolean = false;
  AuthToken: string = ""
  DepartmentId: string = ""
  PageName:string=""
  Department:DepartmentModel=new DepartmentModel();
  @ViewChild('UserDepartmentPagingViewElement', { static: false }) input: ElementRef;
  // Decorator wires up blockUI instance
  ShowPageContent:boolean=false;

  //Add Model Controls
  AddUsersToDepartmentForm = new FormGroup({});
  UserAutoComplete: TagsInputOptions;
  @ViewChild('CloseAddUsersToDepartment', { static: false }) CloseAddUsersToDepartment: ElementRef;
  language:string=""

  //delete  Model Controls
  deleteUserId: number;
  @ViewChild('CloseDeleteUserFromDepartmentModal', { static: false }) CloseDeleteUserFromDepartmentModal: ElementRef;
    sectorName: string;

  constructor(public utilityService:UtilityService,private bbsfTranslateService:BBSFTranslateService,private environmentService:EnvironmentService,private activatedRoute: ActivatedRoute, private dataServices: DataSecretService, private authService: AuthService, private departmentService: DepartmentService, private pageInfoService: PageInfoService, private modalService: NgbModal) {
    this.activatedRoute.params.subscribe(params => {
      this.DepartmentId = params['id'];
      this.SecondUrl=`/Admin/Sectors/SectorInfo/${localStorage.getItem("SectorId")}`
    });
  }
  async ngOnInit(): Promise<void> {
    this.ShowPageContent=true;
    this.bbsfTranslateService.onLangChange.subscribe((event)=>{
      this.ShowPageContent=false;
      this.language = event.lang;
      this.ngOnInit();
    })
    this.language =  await this.utilityService.getCurrentLanguage();
    this.LoadUserList();
  
  }

 

  ReinitializeUserDepartmentPaging() {
    let element = this.input as any;
    element.ReinitializePaging();
  }

  UpdateUserDepartmentPaging() {
    let element = this.input as any;
    element.UpdatePaging();
  }

  setUserDepartmentListResult(result) {
    this.UserDepartmentPagingResult = result
    this.ShowPageContent=true;
    this.utilityService.stopBlockUI()
  }

  resetFilters() {
    this.UserDepartmentForm.controls["searchTextBox"].setValue(null);
    let element = this.input as any;
    element.ReinitializePaging();
  }

  LoadUserList() {
    this.departmentService.getDepartmentInfo(this.DepartmentId).subscribe((result) => {
      this.IsFilterLoaded=false
      let resultModel= result as any
       //console.log(resultModel.val);
      this.Department.SectorId= resultModel.val.sectorId;
      this.SubheaderTitle = resultModel.val.departmentName;
      let sectorName = resultModel.val.sectorName;


      PageInfoService.PageTitle=this.SubheaderTitle 
      PageInfoService.PageBreadcrumbs=[
         {title: this.utilityService.getResourceValue("Home") , path: '/Admin/Home', isSeparator: false, isActive: false},
         {title: '', path: '', isSeparator: true, isActive: false},
         {title: this.utilityService.getResourceValue("Sectors") , path: '/Admin/Sectors/Sector', isSeparator: false, isActive: false},
         {title: '', path: '', isSeparator: true, isActive: false},
         {title: sectorName , path: `/Admin/Sectors/SectorInfo/${this.Department.SectorId}`, isSeparator: false, isActive: false},
         {title: '', path: '', isSeparator: true, isActive: false}
    
      ]; 

      this.pageInfoService.calculateTitle();
      this.pageInfoService.calculateBreadcrumbs();

    // TextBox inti
    this.searchTextBox = new TextBoxOptions();
    this.searchTextBox.Name = "searchTextBox"
      this.searchTextBox.HideLabel = true
    this.searchTextBox.Type = InputType.Text
      this.searchTextBox.Placeholder = this.utilityService.getResourceValue("SearchByNameOrEmail");

    this.DepartmentIdTextBox = new TextBoxOptions();
    this.DepartmentIdTextBox.Name = "DepartmentIdTextBox"
      this.DepartmentIdTextBox.HideLabel = true
    this.DepartmentIdTextBox.Type = InputType.Text
    this.DepartmentIdTextBox.Value = this.DepartmentId;

    this.TextInputFilter = new FilterItem();
    this.TextInputFilter.FormControlName = "searchTextBox"
    this.TextInputFilter.ActionParameterName = "searchText"
    this.TextInputFilter.IsFormControl = true
    this.TextInputFilter.FilterType = FilterType.TextBox

    this.DepartmentIdTextInputFilter = new FilterItem();
    this.DepartmentIdTextInputFilter.FormControlName = "DepartmentIdTextBox"
    this.DepartmentIdTextInputFilter.ActionParameterName = "DepartmentId"
    this.DepartmentIdTextInputFilter.IsFormControl = true
    this.DepartmentIdTextInputFilter.FilterType = FilterType.TextBox

    this.UserDepartmentPaging = new PagingOptions();
    this.UserDepartmentPaging.ActionPostURL = this.environmentService.getApiUrl() + this.ApiUrl + 'GetUsersByFilter';
    this.UserDepartmentPaging.OnKeyPressFiltersControlNames = ["searchTextBox", "DepartmentIdTextBox"]
    this.UserDepartmentPaging.Filters = [this.TextInputFilter, this.DepartmentIdTextInputFilter]
    this.UserDepartmentPaging.ValidationToken = this.authService.authorizationHeaderValue()
    this.IsFilterLoaded = true;
     
  });
  }



  showAddUserToDepartmentModal(AddUserModal) {
    this.utilityService.startBlockUI();
    this.AddUsersToDepartmentForm = new FormGroup({});

    this.UserAutoComplete = new TagsInputOptions();
    this.UserAutoComplete.Name = "UserAutoComplete";
    this.UserAutoComplete.LabelKey = "Users";
    this.UserAutoComplete.IsRequired = true;
    this.UserAutoComplete.Value = null;
    this.UserAutoComplete.ActionURL = this.environmentService.getApiUrl() + this.ApiUrl + "AutoCompleteUserList"
    this.UserAutoComplete.ValidationToken = this.authService.authorizationHeaderValue()
    this.modalService.open(AddUserModal);
    this.utilityService.stopBlockUI();
  }

  addUserToDepartment() {
    if (this.AddUsersToDepartmentForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.AddUsersToDepartmentForm.value;
      let AddModel:DepartmentUsersIDRequestModel= new DepartmentUsersIDRequestModel() ;
      for (let index = 0; index < ResultModel.UserAutoComplete.length; index++) {
        const key = ResultModel.UserAutoComplete[index].key;
        AddModel.UsersIDs.push(Number(key))
        
      }
      AddModel.DepartmentId=Number(this.DepartmentId);
      this.departmentService.addUsersToDepartment(AddModel).subscribe((result) => {
        this.modalService.dismissAll();
        let element = this.input as any;
        element.ReinitializePaging();
      }, (error) => {
        
      })
    }
  }


  showDeleteUserFromDepartmentModal(user: any, DeleteUserModal) {
    this.utilityService.startBlockUI();
    this.deleteUserId = user.id
    this.modalService.open(DeleteUserModal);
    this.utilityService.stopBlockUI();

  }

  deleteUserFromDepartment() {
    this.departmentService.deleteUserFromDepartment(this.deleteUserId.toString(), this.DepartmentId).subscribe((result) => {
      this.deleteUserId = 0;
      this.modalService.dismissAll();
      let element = this.input as any;
      element.ReinitializePaging();
    }, (error) => {
     
    })
  }


}
